export default __webpack_public_path__ + "static/raydium-30b86990dcbf2be2e7a7a163e8b74f0b.png";